export default "__VITE_ASSET__DAhrUV1j__"